import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { CgSpinner } from "react-icons/cg";
import { Sidebar } from "./sidebar";

export const Route = createFileRoute("/dashboard")({
  beforeLoad: async ({ context, location }) => {
    const user = await context.auth.getUser();

    if (!user) {
      throw redirect({
        to: "/login",
        search: {
          redirect: location.href,
        },
      });
    }

    return { user };
  },
  component: () => (
    <div className="flex w-full">
      <Sidebar />
      <Outlet />
    </div>
  ),
  pendingMs: 0,
  pendingMinMs: 300,
  pendingComponent: () => (
    <div className="flex h-[80vh] w-full flex-col items-center justify-center">
      <CgSpinner className="h-24 w-24 animate-spin" />
    </div>
  ),
});
